import { InjectionToken } from "@angular/core";

export const WindowRef = new InjectionToken<Window>("window ref"); // eslint-disable-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
